
import { createContext, useReducer } from "react";
import ClientReducer from "./ClientReducer";

const INITIAL_STATE = {
    clients: [],
    count: 1,
    isFetching: false,
    error: false,
    client: {},
    isFetchingAdd: false,
    errorAdd: false,
    isFetchingUpdate: false,
    errorUpdate: false,
    isFetchingActivate: false,
    errorActivate: false,
};


export const ClientContext = createContext(INITIAL_STATE);

export const ClientContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(ClientReducer, INITIAL_STATE);
    
    return (
      <ClientContext.Provider
        value={{
          clients: state.clients,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          client: state.client,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          isFetchingActivate: state.isFetchingActivate,
          errorActivate: state.errorActivate,
          dispatch,
        }}
      >
        {children}
      </ClientContext.Provider>
    );
  };